import { inject, Injectable } from '@angular/core';
import { TimelineService } from '@app/client';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimelineFacade {
  timelineService = inject(TimelineService);

  getTimeline(projectId: string) {
    return this.timelineService.getTimeline(projectId).pipe(
      map((items) =>
        items.map((item) => ({
          operator: item.operator,
          type: item.type,
          createdAt: item.createdAt,
          title: item.title,
          description: item.description,
          icon: item.icon,
          agent: item.agent,
          user: item.user,
          extras: item.extras,
        })),
      ),
    );
  }
}
